import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';

@Component({
  selector: 'app-logout',
  template: '<div>Redirecting to logout...</div>',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class LogoutComponent implements OnInit {
  
  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    const config = this.appService.readConfig();
    const returnUrl = encodeURIComponent(window.location.origin);
    const gatewayUrl = `${config.gatewayLoginUrl}?loginUrl=${returnUrl}`;
      
    window.location.href = gatewayUrl;
    }
}